import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from '@app/image/image.module';
import { CoreModule } from '@app/core/core.module';
import { SocketService } from '@app/core/services/socket.service';
import { StateService } from '@app/core/services/state.service';
import { Sport,Tournament,Match,SMatch,Odds } from '@app/core/models/models';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatchModalComponent } from './match-modal.component';
import { RouterModule } from '@app/router/router.module';
import { Helper } from '@app/core/helper';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { skip, takeUntil } from 'rxjs/operators';
import { FavoritesService } from '@app/core/services/favorites.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'div.translation__match.match',
    templateUrl: '../templates/match.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ImageModule,
        CoreModule,
        RouterModule],
})
export class MatchComponent implements OnInit,OnDestroy {
    @Input() sport!: Sport;
    @Input() tour!: Tournament;
    @Input() match!: Match;
    ofs: number = this.ss.tZ$.value.offset;
    @Output() closed: EventEmitter<number> = new EventEmitter();
    d$: Subject<boolean> = new Subject();
    mRef!: BsModalRef;
    bkUrl!: string;
    constructor(
        private sks: SocketService,
        public ss: StateService,
        private cdr: ChangeDetectorRef,
        private ms: BsModalService,
        public fs:FavoritesService,
        public ar:ActivatedRoute,
        public r:Router,
    ) {
        this.bkUrl = environment.bk.url;
        this.ss.tZ$.pipe(takeUntil(this.d$), skip(1)).subscribe((res) => {
            this.ofs = res.offset;
            this.cdr.detectChanges();
        });
        this.fs.isChange .pipe(takeUntil(this.d$))
        .subscribe(()=>{
            this.cdr.detectChanges();
        })
    }
    ngOnInit(): void {
        this.sks
            .on('live-score')
            .pipe(takeUntil(this.d$))
            .subscribe((res: Array<SMatch>) => {
                this.updateView(res);
            });
        this.match.period = this.ss.getPeriod(
            this.sport.id,
            this.match.match_status
        );
    }
    ngOnDestroy(): void {
        this.d$.next(true);
        this.d$.complete();
    }
    getStreamUrl() {
        let p = `/watch/${
            this.sport.alias || this.sport.id
        }/${this.tour.alias || this.tour.id}/${this.match.id}/`;
        return p;
    }
    liveState(): string {
        return Helper.liveState(this.match, this.sport);
    }
    updateView(s: Array<SMatch>) {
        let m = s.find((el) => {
            return el.main_const_id === this.match.match_id;
        });
        if (
            m &&
            ((m.status !== 'live' && m.status !== 'not_started') ||
                m.status !== this.match.status)
        ) {
            this.closed.emit(m.main_const_id);
        }
        if (m) {
            this.match.status = m.status;
            this.match.match_status = m.match_status;
            this.match.time_sec = m.time_sec;
            this.match.score = m.score;
            this.match.status === 'live'
                ? (this.match.period = this.ss.getPeriod(
                      this.sport.id,
                      m.match_status
                  ))
                : null;
            if (this.match.odds?.k && m[this.match.odds.k]) {
                this.match.odds.e = m[this.match.odds.k] as Odds[];
            }
            this.cdr.detectChanges();
        }
    }
    disStr(type: number): string {
        if ([1, 3653, 401].indexOf(type) !== -1) {
            return 'W1';
        }
        if ([3, 3655, 402].indexOf(type) !== -1) {
            return 'W2';
        }
        return 'X';
    }
    trackByI(index: number) {
        return index;
    }
    concatLink(url1: any, url2: any): string {
        if (!url2) {
            return url1;
        }
        return (
            url1.replace(/\/$/, '') +
            '/' +
            this.ss.language.code +
            url2.substr(3)
        );
    }
    openModal(odds?: any) {
        if (odds === null) {
            this.mRef = this.ms.show(MatchModalComponent, {
                class: 'modal-bkn',
            });
        } else {
            return;
        }

    }
    saveUrl(){
        this.ss.prevUrl = this.r.url.slice(0, this.r.url.indexOf('?'))
        this.ss.prevParams = this.ar.snapshot.queryParams;
    }
}
